<template>
  <!-- 发票管理 -->
 <div >
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true" ref="" class="demo-form-inline" label-width="110px" size="mini">
        <div class="searchBox inpBox">
            <div class="item">
               <el-form-item label="发票号:" prop="invoiceNo">
                <el-input  placeholder="" v-model="searchFrom.invoiceNo"></el-input>
              </el-form-item>
              <el-form-item label="发票编号:" prop="serialNumber">
                <el-input  placeholder="" v-model="searchFrom.serialNumber"></el-input>
              </el-form-item>
              <el-form-item label="开票状态:" prop="invoiceStatus">
                <el-select  v-model="searchFrom.invoiceStatus"   placeholder="请选择">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="待开票" value="1"></el-option>
                  <el-option label="处理中" value="2"></el-option>
                  <el-option label="可开票" value="3"></el-option>
                  <el-option label="已开票" value="4"></el-option>
                  <el-option label="已邮寄" value="5"></el-option>
                </el-select>
              </el-form-item>
               <el-form-item label="业务类型:" prop="invoiceType">
                <el-select  v-model="searchFrom.invoiceType"   placeholder="请选择">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="运输业务" value="1"></el-option>
                  <el-option label="快递业务" value="2"></el-option>
                  <el-option label="找车业务" value="3"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="开票企业:" prop="platformZxAccNm">
                <el-input  placeholder="" v-model="searchFrom.platformZxAccNm"></el-input>
              </el-form-item>
              <el-form-item label="开票日期:" prop="wayInvoiceDates">
                <el-date-picker
                  v-model="searchFrom.wayInvoiceDates"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
            </div>
        </div>
       <div class="searchBtnBox">
           <el-form-item btnCode="00JP00BB001" v-if="btnFlg[0]">
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
          <el-form-item btnCode="00JP00BB006" v-if="btnFlg[4]">
            <el-button type="primary" @click="DBKPfn">生成发票</el-button>
          </el-form-item>
          <el-form-item btnCode="00JP00BB007" v-if="btnFlg[5]">
            <el-button type="primary" @click="SQKPfn">申请开票</el-button>
          </el-form-item>
           <el-form-item>
             <el-button type="primary"  @click="exportFn" :disabled="isDisable">导出</el-button>
          </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"   :row-class-name="tableRowClassName" height="100%"
      style="width: 100%" center border row-key="id" lazy :load="load" :tree-props="{children: 'children'}">
      <el-table-column   prop="date" width="50" label=""></el-table-column>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index"  prop="date" width="55" label="序号" ></el-table-column>
         <el-table-column label="操作" width="150">
            <template slot-scope="scope">
              <div>
              <el-button type="text" size="mini" btnCode="00JP00BB004"  v-if="(scope.row.invoiceStatus==1)&&btnFlg[3]&&!scope.row.ischildren"  @click="delFN(scope.row)">删除</el-button>
              <!-- <el-button type="text" size="mini" btnCode="00JP00BB003"  v-if="scope.row.invoiceStatus==2&&btnFlg[2]"  @click="chehuiFN(scope.row)">撤回</el-button> -->
               <el-button type="text" size="mini" v-if="btnFlg[6]&&scope.row.invoiceStatus!=1&&!scope.row.ischildren"    @click="lookfapiaoFN(scope.row)" >查看发票</el-button>
              <el-button type="text" size="mini"  v-if="btnFlg[7]&&scope.row.invoiceStatus!=1&&!scope.row.ischildren" :disabled="isDisable"    @click="xiazaifapiaoFN(scope.row)" >下载发票</el-button>
              </div>
            </template>
        </el-table-column>
        <!-- <el-table-column property="serialNumber" width="200"  :formatter="emptyFn"   label="申请流水"></el-table-column> -->
        <el-table-column property="orderNum" label="单据数量">
          <template scope="scope">
               <el-button type="text" size="mini" btnCode="006P009B003" v-if="!scope.row.ischildren"   @click="danjuFN(scope.row)">{{scope.row.orderNum}}</el-button>
               <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="发票编号"  width="200"  property="serialNumber" :formatter="emptyFn">
          <template slot-scope="scope">
              <span type="text" size="mini" v-if="!scope.row.ischildren">{{scope.row.serialNumber}}</span>
              <span v-else>-</span>
          </template>
        </el-table-column>
         <el-table-column property="invoiceStatus" label="发票状态">
          <template scope="scope">{{[ "待开票", "处理中","可开票","已开票", "已邮寄"][scope.row.invoiceStatus-1]}}</template>
        </el-table-column>
         <el-table-column property="invoiceType" label="业务类型">
          <template scope="scope">{{[ "运输业务", "快递业务","找车业务"][scope.row.invoiceType-1]}}</template>
        </el-table-column>
          <el-table-column property="platformZxAccNm"  width="320"  :formatter="emptyFn"   label="开票企业"></el-table-column>
         <el-table-column label="发票税率"  width="120" property="wayAxrate" :formatter="emptyFn">
            <!-- <template slot-scope="scope">
              <span>{{scope.row.wayAxrate*100}}%</span>
            </template> -->
        </el-table-column>
         <el-table-column property="wayMoney"  width="120"  :formatter="emptyFn"   label="发票金额(元)"></el-table-column>
        <el-table-column property="issuingOffice"  width="200"  :formatter="emptyFn"   label="开票单位"></el-table-column>
        <el-table-column property="wayInvoiceNo"  width="200"  :formatter="emptyFn"   label="发票号"></el-table-column>
        <el-table-column property="expressCompany"  width="200"  :formatter="emptyFn"   label="快递公司"></el-table-column>
        <el-table-column property="expressNo"  width="200"  :formatter="emptyFn"   label="快递单号"></el-table-column>
        <el-table-column property="createTime"  width="170"  :formatter="dateTimeFormat"   label="打包时间"></el-table-column>
        <el-table-column width="170" property="wayInvoiceDate" :formatter="dateFormat" label="开票日期"></el-table-column><!--20230614开票时间改成开票日期取值billingTime换成wayInvoiceDate-->
        <el-table-column width="170" property="postageTime" :formatter="dateTimeFormat" label="邮寄时间"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,300,500]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 申请开票 -->
    <el-dialog  title="申请开票"  :visible.sync="dialogSQ" width="400px" class="detail"  :close-oni-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
       <el-form :inline="true"  :model="SQfrom" ref="SQfrom" class="demo-form-inline jiaoyan" label-width="100px" size="mini">
        <div class="inpBox">
              <el-form-item prop="password" label="邮费:">
                  <span style="color:red;font-size:18px">{{SQfrom.youfei}}</span>元
              </el-form-item>
             <el-form-item prop="password" label="支付密码:">
                  <el-input
                    v-model="SQfrom.password"
                    maxlength="20"
                    show-password
                    placeholder="请输入密码"
                  ></el-input>
                </el-form-item>
        </div>
        <div style="background: rgba(225,50,70,0.1);padding: 4px 20px; margin-top:20px">
            <p>提示</p>
            <p>每月首次申请开票免发票邮寄费用！</p>
        </div>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="SQsave()">确认申请</el-button>
        <el-button @click="dialogSQ = false">关闭</el-button>
      </span>
   </el-dialog>
   <!-- 单据明细 -->
    <el-dialog  title="单据明细"  :visible.sync="dialogDJMX" width="1100px" class="detail"  :close-oni-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
      <div class="table">
        <el-table :data="DJMXlist"  v-if="row.invoiceType==1" ref="DJMXlist" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods' height="400" style="width: 100%" center border>
        <el-table-column type="index" fixed prop="date" width="55" label="序号"></el-table-column>
        <el-table-column property="businessNo"  width="200"  :formatter="emptyFn"   label="业务编号"></el-table-column>
         <el-table-column property="publishPricingMethod" label="计价方式">
          <template scope="scope">{{[ "单价", "包干",][scope.row.pricingMethod-1]}}</template>
        </el-table-column>
         <el-table-column property="unitPrice" width="100"     label="单价">
          <template scope="scope">
            <div>
            <span v-if="scope.row.pricingMethod==1">{{scope.row.unitPrice}}元/{{scope.row.unitMeasurement}}</span>
            <span v-if="scope.row.pricingMethod==2">{{scope.row.unitPrice}}元/车</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="weight"  width="120"  :formatter="emptyFn"   label="结算量(吨)"></el-table-column>
         <el-table-column property="wayMoney"  width="120"  :formatter="emptyFn"   label="运费(元)"></el-table-column>
        <el-table-column label="税率(%)"  width="120" :formatter="emptyFn" property="serviceAxrate">
            <template slot-scope="scope">
              <span>{{scope.row.serviceAxrate*100}}</span>
            </template>
        </el-table-column>
         <el-table-column property="serviceMoney"  width="120"  :formatter="emptyFn"   label="服务费(元)"></el-table-column>
        <el-table-column label="合计(元)"  width="120">
            <template slot-scope="scope">
              <span style="color: #0e6eec;cursor: pointer;" >{{scope.row.totalAmount}}</span>
            </template>
        </el-table-column>
      </el-table>
      <el-table :data="DJMXlist" v-else  ref="DJMXlist" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods' height="400" style="width: 100%" center border>
        <el-table-column type="index" fixed prop="date" width="55" label="序号"></el-table-column>
        <el-table-column property="businessNo"  width="200"  :formatter="emptyFn"   label="业务编号"></el-table-column>
         <el-table-column property="invoiceType" label="业务类型">
          <template scope="scope">{{[ "运输业务", "快递业务","找车业务" ][scope.row.invoiceType-1]}}</template>
        </el-table-column>
        <el-table-column property="wayMoney"  width="120"  :formatter="emptyFn"   label="费用(元)"></el-table-column>
         <el-table-column width="170" property="settlementTime" :formatter="dateTimeFormat" label="结算时间"></el-table-column>
      </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogDJMX = false">关闭</el-button>
      </span>
   </el-dialog>
   <!-- 查看发票 -->
    <el-dialog  title="查看发票"  :visible.sync="dialogCkFP" width="460px"  :close-oni-click-modal="false" :close-on-press-escape="false" center>
     <div>
        <p  v-for="item in filelist" :key="item.fileId"><el-button type="text" @click="lookfapiaoFN1(item.url)" >{{item.name}}</el-button></p>
     </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogCkFP = false">关闭</el-button>
      </span>
   </el-dialog>
 </div>

</template>

<script>
import { getBtn } from '@/utils/getButton'
import { encryption, emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
import { invoiceList, vailPostageMoney, invoiceUpdates, listSettles, getAllFileShow } from '@/api/consignment'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import { fileDownAll } from '@/utils/fileDownAll.js'
export default {
  data () {
    return {
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      h: '500px',
      // 查询调价
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      tableList: [],
      loading: 'false',
      total: 0,
      // 申请开票
      dialogSQ: false,
      SQfrom: {
        youfei: 0
      },
      // 单据明细
      dialogDJMX: false,
      DJMXlist: [],
      row: {},
      rules: {
        reason: { required: true, message: '请输入拒绝原因', trigger: 'blur' }
      },
      ids: [],
      isDisable: false,
      maps: new Map(),
      dialogCkFP: false, // 查看发票文件
      filelist: [],
      btnFlg: [],
      btnIdArr: ['00JP00BB001', '00JP00BB002', '00JP00BB003',
        '00JP00BB004', '00JP00BB006', '00JP00BB007', '00JM0F0100', '00JM0F0200']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/payCustomer/invoice')
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 92) + 'px'
  },
  methods: {
    // 查看发票
    lookfapiaoFN (row) {
      getAllFileShow([
        {
          businessId: row.id,
          businessType: 'owner_invoice_file'
        }
      ]).then(res => {
        if (res.length == 0) {
          this.$alert('暂无发票文件', '系统提示')
        } else if (res.length == 1) {
          let tempwindow = window.open('_blank') // 先打开页面
          tempwindow.location = res[0].filePathLook// 后更改页面地址
        } else {
          this.dialogCkFP = true
          res.forEach((item, index) => {
            let name = item.urlPrimary.split('/')
            this.$set(this.filelist, index, { status: 'ready', name: name[name.length - 1], url: item.filePathLook, fileId: item.fileId })
          })
        }
      })
    },
    // 弹框查看发票
    lookfapiaoFN1 (url) {
      let tempwindow = window.open('_blank') // 先打开页面
      tempwindow.location = url// 后更改页面地址
    },
    // 下载发票
    xiazaifapiaoFN (row) {
      getAllFileShow([
        {
          businessId: row.id,
          businessType: 'owner_invoice_file'
        }
      ]).then(res => {
        if (res.length == 0) {
          this.$alert('暂无发票文件', '系统提示')
        } else if (res.length == 1) {
          let tempwindow = window.open('_blank') // 先打开页面
          tempwindow.location = res[0].url// 后更改页面地址
        } else {
          this.isDisable = true
          fileDownAll(
            this.global.payServer + '/owner/invoice/downLoadZip',
            { id: row.id },
            row.serialNumber,
            '.zip'
          )
          setTimeout(() => {
            this.isDisable = false // 点击一次时隔两秒后才能再次点击
          }, 2000)
        }
      })
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.ischildren) {
        return 'nocheck'
      }
    },
    load (tree, treeNode, resolve) {
      this.maps.set(tree.id, { tree, treeNode, resolve })
      let data = { ...tree }
      data.id = 'c' + data.id
      data.wayAxrate = data.serviceAxrate
      data.wayMoney = data.serviceMoney
      data.wayInvoiceNo = data.serviceInvoiceNo
      data.hasChildren = false
      data.ischildren = true
      resolve([
        data
      ])
    },
    // 导出
    exportFn () {
      let form = this.searchFrom
      exportExcel(
        this.global.payServer + '/owner/invoice/exportSocInvoiceList',
        form,
        '发票管理列表'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 打包开票
    DBKPfn () {
      this.$router.push({ path: '/payCustomer/invoiceApply' })
    },
    // 单据数量
    danjuFN (row) {
      this.row = row
      listSettles({ invoiceId: row.id }).then(res => {
        this.DJMXlist = res
        this.dialogDJMX = true
      })
    },
    // 删除
    delFN (row) {
      this.$confirm('是否执行删除操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        invoiceUpdates({ ids: [row.id], flag: 0 }).then(res => {
          loading.close()
          this.$message({
            message: '成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 撤回
    chehuiFN (row) {
      this.$confirm('是否执行撤回审核?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        invoiceUpdates({ ids: [row.id], flag: 1 }).then(res => {
          loading.close()
          this.$message({
            message: '成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 申请开票
    SQKPfn () {
      const selectData = this.$refs.table.selection
      if (selectData.length < 1) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else {
        let isHQ = false
        this.ids = []
        selectData.some(item => {
          if (item.invoiceStatus != 1) { //
            this.$alert('该状态下的数据不能申请开票', '系统提示')
            isHQ = false
            return true
          } else {
            this.ids.push(item.id)
            isHQ = true
          }
        })
        if (isHQ) {
          this.SQJiekou()
        }
      }
    },
    SQsave () {
      let data = encryption({
        data: this.SQfrom,
        key: this.global.key,
        param: ['password']
      })
      this.SQJiekou(data.password)
    },
    SQJiekou (payPwd) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      invoiceUpdates({
        flag: 2,
        ids: this.ids,
        payPwd: payPwd
      }).then(res => {
        loading.close()
        this.$message({
          message: '成功',
          type: 'success'
        })
        this.getList(this.searchFrom)
        this.dialogSQ = false
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcodes) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcodes.split(/[(\r\n)\r\n]+/) }

      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      invoiceList(searchFrom).then(res => {
        this.loading = false
        res.list.forEach(item => {
          if (this.maps.get(item.id)) {
            const { tree, treeNode, resolve } = this.maps.get(item.id)
            this.load(item, treeNode, resolve)
          }
        })
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    billDetails (row) {
      this.$router.push({ name: 'billDetails', query: { billId: row.id } })
    },

    // 重置
    resetForm (formName) {
      // debugger
      // this.$refs[formName].resetFields()
      // this.searchFrom.createTime=null
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        applyTime: null
      }
    },
    closeDialog () {
      this.addForm = {}
      this.CHFrom = {}
    }
  }
}
</script>

<style scoped lang='less'>
.inpBox .el-date-editor{
      width: 350px!important;
}
/deep/.nocheck .el-checkbox{
  display: none;
}
</style>
